// extracted by mini-css-extract-plugin
export default {"main":"cardbase_main__LlE48","mainm":"cardbase_mainm__eQXQN","name":"cardbase_name__wQT5Z","price":"cardbase_price__gxF3v","button":"cardbase_button__caE9Y"};